
// The type of exception thrown
export class CancellationError extends Error {
    public message = "User cancelled the operation";
}

type RejectFn = (reason?:any) => void;

// A simple cancellation token
export class CancellationToken {
    private cancelled:boolean;
    private promiseReject!:RejectFn;
    private promise:Promise<any>;

    constructor() { 
        this.cancelled = false;
        const self = this; // make sure we get the right this in the following
        this.promise = new Promise<any>((_,rej) => {
            self.promiseReject = rej; // save it off
        })
    }

    public cancel() {
        this.cancelled = true;
        if (this.promiseReject) {
            
            this.promiseReject(new CancellationError());
        }
    }

    public check() {
        if (this.cancelled) {
            throw new CancellationError();
        }
    }

    public async awaitCancel(): Promise<any> {
        return this.promise;
    }

    public async withCancel(inner:Promise<any>) : Promise<any> {
        // return first done; error or not
        return Promise.race([inner, this.promise]);
    }

    public async withCancelTimeout(inner:Promise<any>, timeoutMs:number) : Promise<any> {
        const timeoutPromise:Promise<any> = new Promise((res, rej) => 
            setTimeout(() => rej(new Error("Operation timed out")), timeoutMs));
        // return first done; error or not
        return Promise.race([inner, this.promise, timeoutPromise]);
    }
}